export default __webpack_public_path__ + "static/Img_3-4dd79c6af452fefe115da14087cc8fab.jpg";